import { render, staticRenderFns } from "./ToolsEdgeContact.vue?vue&type=template&id=0b405ee4&scoped=true"
import script from "./ToolsEdgeContact.vue?vue&type=script&lang=js"
export * from "./ToolsEdgeContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b405ee4",
  null
  
)

export default component.exports